<template>
  <UIDialog
    v-if="isWeb"
    :visible="visibleSignup"
    class="account-dialog-grpups"
    is-web
    @close="closeSignup"
  >
    <WebSignup
      v-if="visibleSignup"
      @close="closeSignup"
    />
  </UIDialog>

  <UIDialog
    v-else
    ref="dialogSignupRef"
    v-model="visibleSignup"
    class="m-dialog-signup"
    :show-close="false"
  >
    <Signup
      v-if="visibleSignup"
      nested
      closable
      @close="closeSignup"
    />
  </UIDialog>
</template>

<script>
import { ref, unref, computed, onMounted } from '@vue/composition-api'
import { useWindowSize } from '@vueuse/core'
import asyncComponent from '@ms/components/asyncComponent.js'
import UIDialog from '@ms/ui/dialog'
import modalHelper from '@ms/utils/scroll-fixed'
import chatBall from '@ms/components/chat/ball.js'
import { useDomThemeSwitcher } from 'composables/useDomThemeSwitcher.js'

const Signup = asyncComponent(() => import(/* webpackPrefetch: true, webpackChunkName: 'signup' */ 'wap/views/registration/App.vue'))
const WebSignup = asyncComponent(() => import(/* webpackPrefetch: true, webpackChunkName: 'websignup' */ '@ms/desktop/Layout/Signup'))

export default {
  components: {
    UIDialog,
    Signup,
    WebSignup
  },
  setup() {
    const visibleSignup = ref(false)
    const { width } = useWindowSize()
    const isWeb = computed(() => unref(width) >= 750)

    const dialogSignupRef = ref(null)
    onMounted(() => {
      if (!isWeb.value) {
        useDomThemeSwitcher().syncTheme(dialogSignupRef.value?.$el)
      }
    })

    return {
      visibleSignup,
      isWeb,
      dialogSignupRef
    }
  },
  methods: {
    open() {
      this.visibleSignup = true
      modalHelper.afterOpen()
      chatBall.levelUp()
    },
    closeSignup($event) {
      modalHelper.beforeClose()
      this.visibleSignup = false
      chatBall.levelDown()
      if ($event === 'login') {
        this.$login && this.$login()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.m-dialog-signup {
  ::v-deep {
    & > .ui-dialog {
      width: 100%;
      height: 100%;
      background: #000;

      > .ui-dialog--main {
        overflow: auto;
        height: 100%;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
[data-mode="light"].m-dialog-signup {
  ::v-deep {
    & > .ui-dialog {
      background: #f8f8f8;
    }
  }
}
</style>
